export default __webpack_public_path__ + "static/media/graphing-quadrant-blue.3cfa0fa4.svg";